// Logos use CSS custom properties so they follow the token palette.
// Pass explicit accent/ink only when overriding (e.g. inverted contexts).
interface PaceLogoProps { size?: number; accent?: string; }

export function PaceLogo({ size = 32, accent = "var(--accent)" }: PaceLogoProps) {
  return (
    <svg viewBox="0 14 128 48" height={size} role="img" aria-label="Paceroo"
      style={{ color: "var(--ink)" }}>
      <line x1="4" y1="50" x2="115.5" y2="50" stroke="currentColor" strokeWidth="2" strokeLinecap="butt" />
      <g fill="none" stroke="currentColor" strokeLinecap="butt">
        <path d="M 6 46 A 6 6 0 0 1 18 46" strokeWidth="4" />
        <path d="M 24 46 A 12 12 0 0 1 48 46" strokeWidth="5" />
        <path d="M 55 46 A 24 24 0 0 1 103 46" strokeWidth="6" />
      </g>
      <circle cx="115.5" cy="50" r="8" fill={accent} />
    </svg>
  );
}

interface PaceLockupProps { variant?: "full" | "mark"; scale?: number; accent?: string; }

export function PaceLockup({ variant = "full", scale = 1, accent = "var(--accent)" }: PaceLockupProps) {
  if (variant === "mark") {
    return <PaceLogo size={28 * scale} accent={accent} />;
  }
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10 * scale }}>
      <PaceLogo size={26 * scale} accent={accent} />
      <span style={{
        fontFamily: "var(--font-display)", fontWeight: 700,
        fontSize: 22 * scale, letterSpacing: "-0.01em",
        color: "var(--ink)", lineHeight: 1,
      }}>
        pacero<span style={{ color: accent }}>o</span>
      </span>
    </div>
  );
}
